import { render } from "./ColorPopup.vue?vue&type=template&id=30f29a4a"
import script from "./ColorPopup.vue?vue&type=script&lang=js"
export * from "./ColorPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__